module.exports = __webpack_public_path__ + "img/about-icons-geospatial-web.bc04887d.svg";